import { useContext, useEffect } from "react";
import ShopContext from "../../../hooks/context/ShopContext";
const ProductSort = () => {

  const {
    handleChangeSort,
    sort,
    queryProductsApi,
    selectedFilters
  } = useContext(ShopContext);

  useEffect(() => {
    if(sort.selected)
    queryProductsApi(undefined, selectedFilters, 1, sort)
  }, [sort.selected])

  return (
    <div className='flex sort-container'>
      <div class="form-field sort-bar">
        <label class="form-label" for="sort">Sort By:</label>
        <select
          value={sort.selected}
          onChange={handleChangeSort}
          class="form-select form-select--small ng-pristine ng-valid" ng-model="sorting.current" ng-options="option.label for option in sorting.options">
          <option value="Most Popular" label="Most Popular">Most Popular</option>
          <option value="Best Match" label="Best Match">Best Match</option>
          <option value="Newest" label="Newest">Newest</option>
          <option value="Featured" label="Featured">Featured</option>
          <option value="Name: A to Z" label="Name: A to Z">Name: A to Z</option>
          <option value="Name: Z to A" label="Name: Z to A">Name: Z to A</option>
          <option value="Price: Low to High" label="Price: Low to High">Price: Low to High</option>
          <option value="Price: High to Low" label="Price: High to Low">Price: High to Low</option>
        </select>
      </div>
    </div>
  )
}
export default ProductSort;